module.exports = __webpack_public_path__ + "static/media/4 POINT TONEARM.8a13cc02.png";